import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';
import './ChurchPage.css';

function ChurchNewsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchChurchNews();
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const fetchChurchNews = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/board/churchs`);
      const data = await response.json();

      if (data.success) {
        setPosts(data.data);
      }
    } catch (error) {
      console.error('Error fetching church news:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}.${month}.${day}`;
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/church';
  };

  return (
    <div className="church-wrap">
      <header className="church-header">
        <div className="header-inner">
          <div className="user-menu">
            {user ? (
              <>
                <span className="user-name">{user.nick_name}님</span>
                <button onClick={handleLogout} className="auth-link">로그아웃</button>
              </>
            ) : (
              <>
                <Link to="/login" className="auth-link">로그인</Link>
                <Link to="/signup" className="auth-link">회원가입</Link>
              </>
            )}
          </div>
          <div className="logo-top">
            <Link to="/church" className="logo-main">
              <img src="/images/church-logo.png" alt="다비아샘터교회" />
            </Link>
          </div>
          <div className="nav-row">
            <Link to="/" className="logo-sub" title="다비아 메인으로 이동">
              <img src="/images/dasaem-logo.jpg" alt="대구성서아카데미" />
            </Link>
            <nav>
              <Link to="/">다비아 홈</Link>
              <Link to="/church">교회소개</Link>
              <Link to="/church/news">교회소식</Link>
              <Link to="/church/committee">운영위원회</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="church-main">
        <div className="content-wrap">
          <h1>교회소식</h1>

          {loading ? (
            <div className="loading-state">로딩 중...</div>
          ) : (
            <section className="board-section">
              {user && (user.is_admin === 'Y' || user.nick_name === '정용섭') && (
                <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                  <Link to="/write/churchs" className="btn-write" style={{
                    display: 'inline-block',
                    padding: '8px 16px',
                    backgroundColor: '#748320',
                    color: '#fff',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    fontSize: '14px'
                  }}>
                    글쓰기
                  </Link>
                </div>
              )}
              {posts.length === 0 ? (
                <div className="empty-state">등록된 게시글이 없습니다.</div>
              ) : (
                <table className="board-table">
                  <thead>
                    <tr>
                      <th className="col-no">번호</th>
                      <th className="col-title">제목</th>
                      <th className="col-author">작성자</th>
                      <th className="col-date">날짜</th>
                      <th className="col-views">조회</th>
                    </tr>
                  </thead>
                  <tbody>
                    {posts.map((post, index) => (
                      <tr key={post.document_srl}>
                        <td className="col-no">{posts.length - index}</td>
                        <td className="col-title">
                          <Link to={`/church/news/${post.document_srl}`}>
                            {post.title}
                          </Link>
                        </td>
                        <td className="col-author">{post.nick_name || '익명'}</td>
                        <td className="col-date">{formatDate(post.regdate)}</td>
                        <td className="col-views">{post.readed_count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </section>
          )}
        </div>
      </main>

      <footer className="church-footer">
        <div className="footer-links">
          <a href="http://dabia.net" target="_blank" rel="noopener noreferrer">대구성서아카데미</a>
          <a href="/seoul-church">서울샘터교회</a>
          <a href="https://indiadabia.blogspot.com/" target="_blank" rel="noopener noreferrer">설교링크</a>
        </div>
        <button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      </footer>
    </div>
  );
}

export default ChurchNewsPage;
